// @flow
// actions for the signup dialog on the home and program pages
import { createAction } from "redux-actions"

export const SET_REVOKE_DIALOG_VISIBILITY = "SET_REVOKE_DIALOG_VISIBILITY"
export const setRevokeShareDialogVisibility = createAction(
  SET_REVOKE_DIALOG_VISIBILITY
)
